
import { initWASM } from '../service/get-wasm.js';
import { getPixelSize } from './get-pixel-size.js';

/**
 * 转换颜色格式
 * @param { Uint8Array } colorBuffer - 输入的颜色数据
 * @param { Uint8Array } inputProfileBuffer - 输入色彩空间的 profile
 * @param { number } inMode - 输入颜色格式
 * @param { Uint8Array } outputProfileBuffer - 输出色彩空间的 profile
 * @param { number } outMode - 输出颜色格式
 * @param { number } intent - 映射方式
 * @param { number } flag - 标识
 * @returns { Promise<Uint8Array> }
 */
export function transformBuffer(colorBuffer, inputProfileBuffer, inMode, outputProfileBuffer, outMode, intent, flag) {
    return initWASM()
        .then(function(wasm) {
            const imagePixelSize = Math.floor(colorBuffer.length / getPixelSize(inMode));
            const outputImageSize = imagePixelSize * getPixelSize(outMode);
            
            const inputImagePtr = wasm._malloc(colorBuffer.length);
            const inputProfilePtr = wasm._malloc(inputProfileBuffer.length);
            const outputProfilePtr = wasm._malloc(outputProfileBuffer.length);
            const outputImagePtr = wasm._malloc(outputImageSize);
            

            wasm.HEAPU8.set(colorBuffer, inputImagePtr);
            wasm.HEAPU8.set(inputProfileBuffer, inputProfilePtr);
            wasm.HEAPU8.set(outputProfileBuffer, outputProfilePtr);
            wasm._transformBuffer(inputImagePtr, imagePixelSize, inputProfilePtr, inputProfileBuffer.length, inMode, outputProfilePtr, outputProfileBuffer.length, outMode, outputImagePtr, intent, flag);

            const outputBuffer = wasm.HEAPU8.subarray(outputImagePtr, outputImagePtr + outputImageSize);

            wasm._free(inputImagePtr);
            wasm._free(inputProfilePtr);
            wasm._free(outputProfilePtr);
            wasm._free(outputImagePtr);

            return outputBuffer;
        });
}